import classNames from 'classnames';
import type { UseScreenshotOptions } from 'hooks/useScreenshot';
import { LiferingModalWithScreenshot } from 'layouts/main/sp-header/LiferingModalWithScreenshot.suspense';
import type { PropsWithChildren } from 'react';
import { useCallback, useState } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

interface LifeRingButtonProps {
  e2e: string;
  className?: string;
  defaultMessage?: string;
}

export function LifeRingTrigger({
  e2e,
  children,
  className,
  defaultMessage,
  shouldIgnoreElementOverride: ignoreElementOverride,
}: PropsWithChildren<LifeRingButtonProps & UseScreenshotOptions>) {
  const [isOpened, setIsOpened] = useState(false);
  const close = useCallback(() => setIsOpened(false), []);

  const open = useCallback(() => {
    logAnalytics.trackEvent('Workspace', 'Help request open modal');
    setIsOpened(true);
  }, []);

  return (
    <>
      <div onClick={open} data-e2e={e2e} className={classNames(className)}>
        {children}
      </div>
      {isOpened && (
        <LiferingModalWithScreenshot
          shouldIgnoreElementOverride={ignoreElementOverride}
          onClose={close}
          isOpened={isOpened}
          defaultMessage={defaultMessage}
        />
      )}
    </>
  );
}
